<template>
  <footer class="footer">
    <div class="container">
      <div class="row mb-5">
        <div class="col-12 col-md-6">
          <ul class="footer__links">
            <li><a href="#" class="footer__link">Impressum</a></li>
          </ul>
        </div>
        <div class="col-12 col-md-6 text-md-end">
          <span>COPYRIGHT © Gemeinde Mixdorf 2026</span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            Die Gemeinde Mixdorf gehört zum Verwaltungsbereich des Amtes Schlaubetal und dient zugleich als dessen Sitz.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>Amt Schlaubetal<br>Bahnhofstraße 40<br>15299 Müllrose<br>Tel. 033606 8990</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>

</style>
